import { render, staticRenderFns } from "./editInsight.vue?vue&type=template&id=ffb5b182"
import script from "./editInsight.vue?vue&type=script&lang=js"
export * from "./editInsight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports